import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { Form, FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { PCPModel, PCPPayload, PCPPayloadDetail, PCPCard, CoveredMemberForPcp, PCPGrid } from "src/app/models/pcp";

@Component({
    selector: 'mwp-benefit-enrollment-wizard-pcp',
    templateUrl: './pcp.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PCPComponent implements OnInit {
    @Input() public pcpModel: PCPModel;
    @Output() public emitCancel: EventEmitter<any> = new EventEmitter();
    @Output() public emitComplete: EventEmitter<any> = new EventEmitter();

    public pcpFormGroup: FormGroup;

    constructor(
        private formBuilder: FormBuilder,
    ){

    }

    ngOnInit(){
        let l_FormArray_PCPGrid: FormArray = new FormArray([]);
        
        this.pcpModel.pcpCards.forEach((pcd: PCPCard) => {
            let l_FormArray_PCPPayloadDetail: FormArray = new FormArray([]);

            pcd.coveredMembersForPcp.forEach((cmfp: CoveredMemberForPcp) => {
                l_FormArray_PCPPayloadDetail.push(
                    this.formBuilder.group({
                        memberCoverageUniqueID: [cmfp.memberCoverageUniqueID],
                        physicianID: [null],
                        isPreExisting: [false],
                        pcpId: [null],
                        pcpFirstName: [null],
                        pcpLastName: [null],
                        coveredMemberName: [cmfp.coveredMemberName],
                    })
                );
            });

            l_FormArray_PCPGrid.push(
                this.formBuilder.group({
                    panelHeaderLabelForDisplay: [pcd.panelHeaderLabelForDisplay],
                    pcpLinkText: [pcd.pcpLinkText],
                    pcpLinkURL: [pcd.pcpLinkURL],
                    details: l_FormArray_PCPPayloadDetail,
                })
            );
        });

        this.pcpFormGroup = this.formBuilder.group({
            grids: l_FormArray_PCPGrid,
        });
    }

    get gridArray() {
        return (<FormArray>(this.pcpFormGroup.get('grids'))).controls;
    }

    gridDetailArray(index: number) {
        return (<FormArray>(<FormArray>(this.pcpFormGroup.get('grids'))).controls[index].get('details')).controls;
    }

    public openTab(url: string) {
        window.open(url);
    }

    public cancel(): void {
        this.emitCancel.emit();
    }

    public completeForm() {
        let l_PCPPayloadDetails: PCPPayloadDetail[] = new Array<PCPPayloadDetail>();
        let l_PCPGrid = this.pcpFormGroup.value.grids;

        l_PCPGrid.forEach((pcg: PCPGrid) => {
            pcg.details.forEach((d: PCPPayloadDetail) => {
                let l_PCPPayloadDetail = new PCPPayloadDetail();
                l_PCPPayloadDetail.memberCoverageUniqueID = d.memberCoverageUniqueID;
                l_PCPPayloadDetail.pcpFirstName = d.pcpFirstName;
                l_PCPPayloadDetail.pcpLastName = d.pcpLastName;
                l_PCPPayloadDetail.pcpId = d.pcpId ?? d.pcpId;
                l_PCPPayloadDetail.coveredMemberName = d.coveredMemberName;

                l_PCPPayloadDetails.push(l_PCPPayloadDetail);
            })
        });        

        const l_PCPPayload: PCPPayload = {
            pcpCriterias: l_PCPPayloadDetails,
        };
        this.emitComplete.emit(l_PCPPayload);
    }
}